import React, {Component} from 'react';
import './App.css';
import {BrowserRouter as Router,Route} from 'react-router-dom';
import Home from "./Home/Home";
import Login from "./Login/Login";
import Signup from "./Signup/Signup";
import Plots from "./Plot/Plots";
import PlotMenu from "./Plot-Menu/PlotMenu";
import Maps from "./Map/Map";
import MapList from "./Map-List/MapList";
import AddMap from "./Add-Map/AddMap";
import Switch from "./Switches/Switch";
class App extends Component {

    handleClick = () => {

        // this.setState({pool:'fuckYou'});
    };

    // constructor() {
    //     super();
    //     // fetch('http://localhost:4000/selectall').then(e => {
    //     //     e.json().then(res => {
    //     //         console.log(res);
    //     //         this.setState({pool: res});
    //     //     }).catch(err => {
    //     //         console.log(err.message);
    //     //     });
    //     // }).catch(e => {
    //     //     console.log(e.message);
    //     // });
    //
    // }

    render() {


        return (
            <div>
                <Router>
                    <div>
                        <Route exact path='/' component={Login}/>
                        <Route path='/home' component={Home}/>
                        <Route path='/signup' component={Signup}/>
                        <Route path='/plot' component={Plots}/>
                        <Route path='/plot-menu' component={PlotMenu}/>
                        <Route path='/map' component={Maps}/>
                        <Route path='/map-list' component={MapList}/>
                        <Route path='/add-map' component={AddMap}/>
                        <Route path='/switch' component={Switch}/>
                    </div>
                </Router>
                {/*{this.state.pool.map((name, ind) => {*/}
                    {/*return(<button key={ind}>{name.NAME}</button>);*/}
                {/*})*/}
                {/*}*/}
            </div>
        );
    }
}

export default App;
